// METIS Hub wording — namespace "connect" (en), 505 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/screens/connect.js App.addI18n).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const connect: Record<string, string> = {
  'connect.approval.title': 'Approve VS Code connection',
  'connect.approval.titleCli': 'Approve CLI (terminal) connection',
  'connect.approval.description': 'Connect the extension and CLI to this account.',
  'connect.approval.account': 'Account',
  'connect.approval.app': 'App',
  'connect.approval.server': 'Hub server',
  'connect.approval.code': 'Verification code',
  'connect.approval.recording': 'Usage and records from this app belong to the account above. Your existing consent and company policy apply.',
  'connect.approval.text': 'Questions and answers are recorded within your consent. OpenAI and Anthropic API keys stay on the server.',
  'connect.approval.meta': 'API conversations record usage only. This connection token does not store question or answer text.',
  'connect.approval.providers': 'Available APIs',
  'connect.approval.noProviders': 'No API is available. CLI collection can connect. For API chat, connect again after an administrator configures OpenAI or Anthropic API access and models.',
  'connect.approval.checkCode': 'Approve only a request you started, with the same code shown in the extension or terminal. Requests expire after 10 minutes.',
  'connect.approval.approve': 'Approve connection',
  'connect.approval.deny': 'Deny',
  'connect.approval.approved': 'Approved. The extension or terminal is completing the connection.',
  'connect.approval.consumed': 'Connected. Return to VS Code or the terminal; you can close this window.',
  'connect.approval.denied': 'Connection request denied.',
  'connect.approval.cancelled': 'The extension or terminal cancelled this request.',
  'connect.approval.expired': 'This request expired. Start a new web connection from the extension, or run prs login again in the terminal.',
  'connect.approval.failed': 'This request cannot be opened or processed. Start a new web connection from the extension, or run prs login again in the terminal.',
  'connect.approval.limitTitle': 'The active token limit prevents approval right now',
  'connect.approval.limitBody': 'This account has {active} of {limit} active tokens, and this connection needs {needed} new tokens. Disconnect unused connections or revoke unused API keys in Tool connections to free at least {free}, then approve here.',
  'connect.approval.limitAction': 'Open Tool connections (new tab)',
  "connect.download.title": "Install CLI and VS Code extension",
  "connect.download.desc": "Use the terminal or extension and view your records on the web.",
  "connect.download.windows": "Windows CLI installer",
  "connect.download.portable": "Portable CLI",
  "connect.download.npm": "npm package",
  "connect.download.extension": "VS Code extension",
  "connect.download.unavailable": "Installation files are not published or could not be loaded.",
  "connect.download.help": "CLI: after installing, sign in with prs login (or prsx login if prs belongs to another program). Extension: Install from VSIX, then sign in on the web. No token to type.",
  "connect.setup.title": "Install developer tools in one go",
  "connect.setup.desc": "Install Node.js (npm), Git, GitLab CLI, Codex, Claude Code and the METIS CLI with one script. Tools already installed are skipped.",
  "connect.setup.os": "Operating system",
  "connect.setup.packages": "Tools to install",
  "connect.setup.pkg.node": "Node.js · npm",
  "connect.setup.pkg.git": "Git",
  "connect.setup.pkg.glab": "GitLab CLI",
  "connect.setup.pkg.codex": "Codex CLI",
  "connect.setup.pkg.claude": "Claude Code",
  "connect.setup.pkg.metis": "METIS CLI (prs)",
  "connect.setup.upgrade": "Also update tools already installed",
  "connect.setup.upgradeD": "When off, installed tools are skipped.",
  "connect.setup.copy": "Copy install command",
  "connect.setup.note.windows": "Paste it into PowerShell. Installing Node.js or Git may show an administrator (UAC) prompt. Open a new terminal afterwards.",
  "connect.setup.note.mac": "Paste it into Terminal. Homebrew is installed first when missing and may ask for your Mac password. Open a new terminal afterwards.",
  "connect.setup.note.linux": "Paste it into a terminal. Run it without sudo: it asks for the sudo password only when needed. Open a new terminal afterwards.",
  "connect.setup.options": "Run it without options to pick from a menu. Status: -List / --list, preview: -DryRun / --dry-run.",
  "connect.setup.file": "Download the script ({file})",
  "connect.download.server": "Default server of these files: {url}. Users can switch with prs server set ADDRESS or the server address command of the METIS Hub VS Code extension.",
  "connect.download.serverOther": "The files connect to another server than this Hub",
  "connect.download.serverOtherD": "The installation files were built for {file}, but this Hub is {hub}. Administrators: check APP_DOMAIN in .env and build the files again.",
  "connect.desc": "Check and fix how Claude Code and Codex on your PC — and apps or scripts using API keys — send records.",
  "connect.tabsLabel": "Connect sections",
  "connect.tab.mine": "My connections",
  "connect.tab.new": "Connect a tool",
  "connect.tab.app": "App connections (API key)",
  "connect.tab.team": "Team connections",
  "connect.tab.support": "Support table",
  "connect.tab.coverage": "What gets recorded",
  "connect.noTab.title": "You can’t view this section",
  "connect.noTab.desc": "Team connections are for managers and admins with people & team access.",
  "connect.alert.reconsentDesc": "New records aren’t stored until you agree again. Your tool connections stay as they are.",
  "connect.alert.pausedDesc": "Records sent while paused aren’t stored.",
  "connect.alert.go": "Open My records",
  "connect.mine.q": "Are my PCs sending records properly?",
  "connect.mine.tech": "Connection status · by last received · PC × tool",
  "connect.mine.sumOk": "Everything is sending fine ({n|connection|connections}).",
  "connect.mine.sumSome": "Check {bad} of {n|connection|connections}.",
  "connect.mine.sumRevoked": "{r|disconnected connection receives|disconnected connections receive} nothing.",
  "connect.mine.emptyWhat": "You haven’t connected any tools yet.",
  "connect.mine.emptyNot": "Nothing is recorded before you connect. Once connected, your next question is recorded.",
  "connect.dev.since": "first connected {date}",
  "connect.dev.rename": "Rename",
  "connect.dev.history": "Connection history",
  "connect.mode.direct": "Sends straight to the server",
  "connect.mode.helper": "Sends through the PC helper",
  "connect.f.lastRel": "last received {rel}",
  "connect.f.never": "nothing received",
  "connect.f.version": "CLI version",
  "connect.f.token": "Collect token",
  "connect.f.mode": "How it sends",
  "connect.f.revokedAt": "disconnected {rel}",
  "connect.f.noToken": "no connection token",
  "connect.f.lastUsedRel": "last used {rel}",
  "connect.more": "Details",
  "connect.less": "Hide",
  "connect.token.noExpiry": "no expiry · revoked when you disconnect",
  "connect.token.expired": "Expired",
  "connect.token.revoked": "Revoked",
  "connect.token.expIn": "expires in {d|day|days} · {date}",
  "connect.ver.ok": "Supported",
  "connect.ver.checking": "Support being checked",
  "connect.ver.old": "Below supported version",
  "connect.ver.unknown": "Unknown version",
  "connect.warn.over.title": "Settings send more than you agreed to",
  "connect.warn.over.desc": "This PC’s CLI settings have {what} turned on. It isn’t part of recording level {lv}, so the server drops it before storing.",
  "connect.warn.over.descPolicy": "This PC’s CLI settings have {what} turned on. Company policy turns it off, so the server drops it before storing.",
  "connect.over.prompt": "sending question text",
  "connect.over.answer": "sending AI answer text",
  "connect.over.work_detail": "sending work details (commands, file paths)",
  "connect.over.raw": "sending raw AI requests and responses",
  "connect.tech": "Technical details",
  "connect.tech.find": "Look for this name in the settings file",
  "connect.warn.legacy.title": "Old PoC settings remain",
  "connect.warn.legacy.desc": "The PC check tool found an old test-server address ({addr}). Records may go to two places or go missing.",
  "connect.warn.legacy.fix": "How to clean up",
  "connect.warn.problem.token": "Get a new connection token and apply the settings again.",
  "connect.warn.problem.helper": "Turn on the PC and restart the PC helper. Records waiting to be sent go out once it reconnects.",
  "connect.warn.problem.fix": "Get a new connection token",
  "connect.warn.idle": "Fine if you didn’t use it. If you did and nothing arrived, try [Test record].",
  "connect.act.test": "Test record",
  "connect.act.reconfig": "Get settings again",
  "connect.act.revoke": "Disconnect",
  "connect.act.reconnect": "Connect again",
  "connect.test.title": "Test record",
  "connect.test.wait": "Open a new terminal on this PC and send one question. Waiting for a record from {tool}…",
  "connect.test.checking": "Checking the test record that arrived…",
  "connect.test.ok": "A test record just arrived",
  "connect.test.okMeta": "{time} · {tool} {ver} · {pc}",
  "connect.test.miss": "Nothing received yet",
  "connect.test.missDesc": "Check these one by one.",
  "connect.chk.legacy.t": "Old PoC settings remain",
  "connect.chk.legacy.d": "Records may be going to the old address. Clean it up first.",
  "connect.chk.terminal.t": "Did you send from a new terminal?",
  "connect.chk.terminal.d": "Settings apply from a newly opened terminal.",
  "connect.chk.token.t": "Is the connection token right?",
  "connect.chk.token.d": "Make sure it matches the collect token from step ③. If you lost it, get a new one.",
  "connect.chk.format.t": "Is the format right?",
  "connect.chk.format.d": "Check that the send format in the settings is http/json.",
  "connect.chk.addr.t": "Can you reach the collection server?",
  "connect.chk.addr.d": "Check the company network or VPN can reach {addr}.",
  "connect.chk.help": "Help",
  "connect.path.label": "Where the record travels",
  "connect.path.pc": "AI tool on my PC",
  "connect.path.server": "Company collection server",
  "connect.path.store": "Storage",
  "connect.path.sent": "Sent",
  "connect.path.got": "Received",
  "connect.path.stored": "Stored",
  "connect.path.checkPc": "Check the sending settings",
  "connect.path.notReached": "Not reached",
  "connect.path.dropped": "Dropped before storing",
  "connect.path.stop": "Stopped here",
  "connect.path.sum.ok": "It passed all three steps and was stored.",
  "connect.path.sum.dropped": "It reached the company collection server but stopped before storing.",
  "connect.path.sum.missed": "It stopped between your PC and the company collection server.",
  "connect.flow.label": "Progress",
  "connect.flow.wait": "Waiting",
  "connect.flow.check": "Checking",
  "connect.flow.done": "Done",
  "connect.flow.missed": "Not received",
  "connect.flow.dropped": "Not stored",
  "connect.flow.sr.done": "done",
  "connect.flow.sr.now": "current step",
  "connect.flow.sr.fail": "stopped here",
  "connect.revoke.title": "Disconnect {tool}?",
  "connect.revoke.body": "The collect token on {pc} will be revoked. Records from {tool} on this PC won’t be received anymore. Records already received stay.",
  "connect.revoke.bodyOther": "This revokes the {tool} collect token on {name}’s {pc}. It’s kept in the access & change log and the person is notified.",
  "connect.revoke.confirm": "Disconnect",
  "connect.revoke.done": "Disconnected. The collect token was revoked.",
  "connect.rename.title": "Rename PC",
  "connect.rename.label": "PC name",
  "connect.rename.hint": "Default names look like PC-1. Admins and operations also see this name, so don’t use real names or hostnames.",
  "connect.rename.save": "Save",
  "connect.rename.done": "PC renamed.",
  "connect.rename.err": "Use 1–30 characters.",
  "connect.hist.title": "{pc} · connection history",
  "connect.hist.note": "Only changes to this PC’s connection are shown (no question text).",
  "connect.hist.add": "{tool} connected · collect token issued",
  "connect.hist.first": "First {tool} record received",
  "connect.hist.version": "{tool} changed to {v}",
  "connect.hist.last": "Last {tool} record received",
  "connect.hist.quiet": "{tool} went quiet (no records for 4 hours)",
  "connect.hist.down": "{tool} became not connected (no records for 3 days)",
  "connect.hist.revoked": "{tool} disconnected · collect token revoked",
  "connect.hist.level": "Recording level changed: {lv}",
  "connect.hist.problem": "{tool} error: {why}",
  "connect.legacy.title": "Clean up old PoC settings",
  "connect.legacy.desc": "This command makes a backup, then removes only the old test-server address and header. Other settings you changed stay.",
  "connect.legacy.done": "Cleaned up",
  "connect.legacy.doneToast": "Marked old PoC settings as cleaned up. We’ll check from the next record.",
  "connect.legacy.copy": "Copy cleanup command",
  "connect.wz.label": "Connection wizard steps",
  "connect.wz.progress": "Step {i} of {n} · {label}",
  "connect.wz.s.level": "Recording level",
  "connect.wz.s.tool": "Tool",
  "connect.wz.s.token": "Token",
  "connect.wz.s.apply": "Apply",
  "connect.wz.s.test": "Test",
  "connect.wz.s.result": "Result",
  "connect.wz.level.q": "First, choose how much to record",
  "connect.wz.level.tech": "① Recording level · within the company ceiling · before the settings",
  "connect.wz.level.why": "Each level needs different CLI settings, so you choose it before the settings are made.",
  "connect.wz.notice": "Notice {v} in brief",
  "connect.wz.notice.purpose": "Purpose: managing AI cost and security — never for evaluating work or performance.",
  "connect.wz.notice.keep": "Kept: question & answer text {c} days · usage & basic info {u} days, then deleted automatically",
  "connect.wz.notice.who": "Who can see: you · admins and content reviewers (with a reason, re-sign-in and a per-conversation grant, shown to you)",
  "connect.wz.notice.rights": "You can lower it, pause it or withdraw consent at any time.",
  "connect.wz.cap": "Company ceiling: up to {lv}",
  "connect.wz.capOff": "the company turned off {items}",
  "connect.wz.current": "My recording level now",
  "connect.wz.custom": "Choose items",
  "connect.wz.customHint": "Turn items on or off one by one. If the mix matches a level, it shows as that level.",
  "connect.wz.customOn": "Custom mix",
  "connect.lv.current": "Now",
  "connect.lv.sendLabel": "Sends",
  "connect.lv.notLabel": "Doesn’t send",
  "connect.lv.withdrawLabel": "To withdraw",
  "connect.lv.withdraw": "Lower or pause it any time in My records.",
  "connect.lv.capped": "Above the company ceiling, so it can’t be chosen",
  "connect.lv1.send": "Time, tool, AI model, usage, duration, success, character counts",
  "connect.lv1.not": "Question & answer text, commands, file paths",
  "connect.lv2.send": "① plus question text",
  "connect.lv2.not": "AI answer text, commands, file paths, changes",
  "connect.lv3.send": "② plus AI answer text (Codex: last answer per question, unofficial)",
  "connect.lv3.not": "Commands, file paths, changes",
  "connect.lv4.send": "③ plus commands, file paths and changes (Claude: first 128 chars per value)",
  "connect.lv4.not": "File contents, command output (tool results), the AI’s intermediate thinking",
  "connect.ci.basic": "Always on so you can connect",
  "connect.ci.prompt": "Sends the questions you write",
  "connect.ci.answer": "Sends AI answer text (an unofficial setting for Codex)",
  "connect.ci.work_detail": "Sends commands, file paths and changes (Codex always sends; the server filters)",
  "connect.ci.toolOutputRisk": "turning it on keeps parts of file contents and command output",
  "connect.ci.techLead": "The CLI setting behind each item (Claude Code · Codex). The command in ④ Apply settings changes them for you.",
  "connect.ci.codexAlways": "Codex can’t turn this off (the server filters it)",
  "connect.wz.levelNote": "Changes are kept in your consent history, and other PCs need their CLI settings again.",
  "connect.wz.levelSaved": "Recording level changed: {lv} · kept in your consent history",
  "connect.wz.coverage": "See what gets recorded",
  "connect.wz.consentWarn": "You haven’t agreed to notice {v} yet, so new records won’t be stored even after connecting.",
  "connect.wz.tool.q": "Which AI tool do you want to connect?",
  "connect.wz.tool.tech": "② Tool · CLI tool (Claude Code · Codex)",
  "connect.tool.claude_code.sub": "Anthropic’s AI coding tool · {v} or later",
  "connect.tool.codex.sub": "OpenAI’s AI coding tool · {v} or later",
  "connect.tool.claude_code.file": "Writes only your user settings file (JSON)",
  "connect.tool.codex.file": "Writes only your user settings file (TOML)",
  "connect.tool.connected": "Already connected · {pc}",
  "connect.wz.tool.api": "Apps and scripts that call AI with API keys connect under App connections.",
  "connect.wz.tool.apiGo": "Go to App connections (API key)",
  "connect.wz.tool.locked": "You can’t change the tool when getting settings again.",
  "connect.wz.token.q": "Get a connection token just for this PC",
  "connect.wz.token.tech": "③ Collect token · shown only once",
  "connect.wz.token.which": "Which PC?",
  "connect.wz.token.newPc": "New PC",
  "connect.wz.token.pcName": "New PC name",
  "connect.wz.token.pcHint": "Default names look like PC-1. Don’t use real names or hostnames.",
  "connect.wz.token.replaceNote": "This replaces the {tool} connection on this PC with a new token. The old token is revoked.",
  "connect.wz.token.can": "Can do",
  "connect.wz.token.canV": "Send records only (can’t read or manage)",
  "connect.wz.token.bound": "Tied to",
  "connect.wz.token.exp": "Expires",
  "connect.wz.token.expV": "when you disconnect",
  "connect.wz.token.issue": "Get collect token",
  "connect.wz.token.issued": "Collect token issued. Copy it now.",
  "connect.wz.token.once": "This token is shown only once",
  "connect.wz.token.onceDesc": "It won’t be shown again once you leave this wizard. It’s filled into the settings in ④ automatically. If you lose it, get a new one and the old one is revoked.",
  "connect.wz.token.copy": "Copy collect token",
  "connect.wz.token.hidden": "The token is now hidden · {masked}",
  "connect.wz.token.lost": "If you lost it, get a new one. The old token is revoked.",
  "connect.wz.token.again": "Get a new one (revokes the old)",
  "connect.wz.token.reuse": "Getting the {tool} settings for {pc} again.",
  "connect.wz.token.keep": "Keeps your current collect token ({prefix}••••)",
  "connect.wz.token.keepDesc": "The token in the settings file stays; only the recording-level lines change.",
  "connect.wz.token.replace": "Switch to a new token",
  "connect.wz.needToken": "Get a collect token first.",
  "connect.wz.apply.q": "Paste this command into your terminal",
  "connect.wz.apply.tech": "④ Apply settings · writes only your user settings file",
  "connect.os.label": "Operating system",
  "connect.os.unix": "macOS · Linux",
  "connect.os.win": "Windows",
  "connect.apply.modeLabel": "How to apply",
  "connect.apply.oneline": "One-line command",
  "connect.apply.manual": "Paste manually",
  "connect.apply.onelineDesc": "Merges safely with your existing settings and makes a backup first. This command requires Node.js 24 or later. Choose manual paste if it is not installed. Project folder settings aren’t touched.",
  "connect.apply.askToken": "When run, the command asks for your connection token from step ③. It’s typed hidden and never saved in your shell history.",
  "connect.apply.keepToken": "Your current connection token stays; only the recording-level lines change.",
  "connect.apply.manualDesc": "Open this file and merge in the content below. Only lines for the recording level chosen in ① are included.",
  "connect.apply.onlyLevel": "Leave the token and address lines as they are; change only these lines.",
  "connect.apply.file": "Target file",
  "connect.apply.lgLabel": "Line marks",
  "connect.apply.lgOn": "Lines turned on by the recording level ({lv})",
  "connect.apply.lgOff": "Off values (if left empty they follow another value)",
  "connect.apply.restore": "Undo",
  "connect.apply.restoreDesc": "Restores only the values we wrote, from the backup. Values you changed afterwards stay.",
  "connect.apply.noProject": "Nothing is written to a project folder’s .claude or .codex settings (so tokens never reach a repository).",
  "connect.apply.placeholder": "<collect token from step ③>",
  "connect.apply.restart": "Settings apply from a newly opened terminal.",
  "connect.apply.noToken": "Your connection token goes into the settings once you get it in step ③.",
  "connect.apply.copyCmd": "Copy command",
  "connect.apply.goToken": "Go to ③ to get a token",
  "connect.apply.copyRestore": "Copy undo command",
  "connect.apply.copyFile": "Copy settings",
  "connect.apply.codexUnofficial": "# unofficial · Codex 0.162.1 or later",
  "connect.apply.codexNote": "# Codex always sends work details (④); the server filters them by recording level.",
  "connect.apply.codexKeep": "# metrics_exporter and analytics stay untouched (they affect OpenAI’s own statistics)",
  "connect.wz.test.q": "Open a new terminal and send one question",
  "connect.wz.test.tech": "⑤ Test question · we wait up to 3 minutes",
  "connect.wz.test.s1": "Close the terminal that’s open now and open a new one.",
  "connect.wz.test.s2": "Send one question like this.",
  "connect.wz.test.s3": "Wait here for the first record to arrive.",
  "connect.wz.test.prompt": "This is a connection test. Reply in one line.",
  "connect.wz.test.copy": "Copy test command",
  "connect.wz.test.waiting": "Waiting for the first record",
  "connect.wz.test.elapsed": "{t} elapsed · we wait up to 3 minutes",
  "connect.wz.test.checking": "Checking the record that arrived",
  "connect.wz.test.checkingSub": "Making sure it can be stored",
  "connect.wz.demo": "Mockup: pick a result",
  "connect.wz.check": "Check result",
  "connect.res.ok": "Received & stored",
  "connect.res.dropped": "Received, not stored",
  "connect.res.missed": "Nothing in 3 minutes",
  "connect.wz.result.q": "Did the first record arrive?",
  "connect.wz.result.tech": "⑥ Result · received & stored / received, not stored / nothing in 3 minutes",
  "connect.res.ok.title": "Your first record arrived",
  "connect.res.ok.meta": "{time} · {tool} {ver} · {pc}",
  "connect.res.ok.saved": "Stored at recording level {lv}. This connection now shows under My connections.",
  "connect.res.ok.logs": "See in Activity",
  "connect.res.ok.mine": "See my connections",
  "connect.res.drop.title": "Received, but not stored",
  "connect.res.drop.desc": "The record reached the server but was dropped before storing, for this reason:",
  "connect.res.drop.consent": "It was sent before you agreed to notice {v}.",
  "connect.res.drop.paused": "It was sent while recording was paused.",
  "connect.res.drop.level": "Values outside the chosen recording level were dropped (e.g. question text at level ①).",
  "connect.res.drop.fixConsent": "Go to consent",
  "connect.res.drop.fixLevel": "Choose the recording level again",
  "connect.res.miss.title": "Nothing arrived in 3 minutes",
  "connect.res.miss.desc": "Check these one by one, then send again.",
  "connect.res.miss.back": "Back to ④ Apply settings",
  "connect.res.miss.retry": "Try again",
  "connect.wz.prev": "Back",
  "connect.wz.next": "Next",
  "connect.wz.home": "Go home",
  "connect.wz.restart": "Start over",
  "connect.wz.mobile.title": "Do this on the PC where you use the AI tool",
  "connect.wz.mobile.tech": "Connect a tool · needs a PC terminal",
  "connect.wz.mobile.desc": "The settings command has to be pasted into that PC’s terminal. Send this link to the PC and open it there.",
  "connect.wz.mobile.copy": "Copy link",
  "connect.wz.mobile.peek": "Preview the steps",
  "connect.wz.mobile.copied": "Link copied. Open it on your PC.",
  "connect.app.q": "How do I connect apps and scripts through the company gateway?",
  "connect.app.tech": "API key call · company gateway · gateway token (expires within 90 days)",
  "connect.app.sum": "When an app calls AI through the company gateway, it’s recorded per person and call. Only the gateway holds the company key; your app gets a gateway token.",
  "connect.app.addr": "Gateway address",
  "connect.app.sep": "Usage through API keys shows separately as “API key call” in Home and Insights.",
  "connect.app.tools": "Don’t put this token into Codex or Claude Code. Run prs codex or prs claude in a terminal: they use this gateway automatically when the company has a key (plain codex and claude keep your own sign-in).",
  "connect.app.src": "Company gateway (C3)",
  "connect.app.emptyWhat": "The gateway isn’t on yet. Please contact your admin.",
  "connect.app.emptyNot": "API key calls that don’t go through the gateway aren’t shown per person. That doesn’t mean API keys aren’t used.",
  "connect.app.form": "Issue a gateway token",
  "connect.app.name": "App name",
  "connect.app.namePh": "e.g. support-summarizer",
  "connect.app.purpose": "Purpose",
  "connect.app.purposePh": "e.g. summarizing support tickets",
  "connect.app.owner": "Owner",
  "connect.app.me": "Me ({name})",
  "connect.app.provider": "AI company",
  "connect.app.text": "Text storage policy",
  "connect.app.text.meta": "Basic info only (default)",
  "connect.app.text.metaD": "Keeps only time, AI model, usage, cost and status.",
  "connect.app.text.full": "Also store the last question & answer",
  "connect.app.text.fullD": "Needs an owner, purpose and masking rules. Kept 7 days.",
  "connect.app.text.needAdmin": "Needs admin approval (employee consent alone can’t turn it on)",
  "connect.app.expiry": "Expiry (90 days max)",
  "connect.app.days": "{n} days",
  "connect.app.issue": "Issue gateway token",
  "connect.app.err.name": "Enter an app name.",
  "connect.app.err.purpose": "Enter a purpose.",
  "connect.app.issued": "Gateway token issued. Copy it now.",
  "connect.app.once": "This gateway token is shown only once",
  "connect.app.onceD": "It lets you use the company key, so don’t share it. We’ll remind you 14 days before it expires.",
  "connect.app.copy": "Copy gateway token",
  "connect.app.use": "How to use it in your app",
  "connect.app.use.file": "File",
  "connect.app.use.helper": "Helper command",
  "connect.app.use.fileD": "Keep the token in a file only you can read, and have the app read it at run time. Don’t write it in code or in settings files that go into a repository.",
  "connect.app.use.helperD": "A helper command hands out the token when needed. Settings that send CLI tools through the gateway aren’t offered until duplicate checks are done.",
  "connect.app.another": "Connect another app",
  "connect.gw.q": "When do my gateway tokens expire?",
  "connect.gw.tech": "Gateway tokens · reminder 14 days before expiry",
  "connect.gw.sumSoon": "The {app} gateway token expires in {d|day|days}. Issue a new one before then.",
  "connect.gw.sumOk": "Every gateway token has more than 14 days left ({n|token|tokens}).",
  "connect.gw.sumNone": "No gateway tokens in use.",
  "connect.gw.emptyWhat": "You haven’t issued any gateway tokens.",
  "connect.gw.emptyNot": "Only calls through the gateway are shown per person. That doesn’t mean API keys aren’t used.",
  "connect.gw.left": "{d|day|days} left",
  "connect.gw.never": "never used",
  "connect.gw.soon": "expires in {d|day|days}",
  "connect.gw.renew": "Issue new",
  "connect.gw.revoke": "Revoke",
  "connect.gw.renewAsk": "Issue a new gateway token for {app}?",
  "connect.gw.renewAskD": "The new token is shown only once. The old token is revoked right away.",
  "connect.gw.renewTitle": "New gateway token · {app}",
  "connect.gw.renewDone": "New gateway token issued. The old one was revoked.",
  "connect.gw.revokeTitle": "Revoke the {app} gateway token?",
  "connect.gw.revokeBody": "Apps calling with this token will get 401 errors right away.",
  "connect.gw.revokeDone": "Gateway token revoked.",
  "connect.keys.q": "Which API keys are registered?",
  "connect.keys.tech": "API key registry · only the last 4 characters show · {scope}",
  "connect.keys.scopeAll": "all company keys",
  "connect.keys.scopeMine": "keys I own",
  "connect.keys.sum": "{a} of {n|key|keys} in use.",
  "connect.keys.sumGrace": "{a} of {n|key|keys} in use, {g} in the replacement grace period.",
  "connect.keys.emptyWhat": "No API keys are registered under your name.",
  "connect.keys.emptyNot": "Admins register company keys. Apps use them through gateway tokens.",
  "connect.keys.src.admin_api": "Org sync",
  "connect.keys.src.manual": "Added manually",
  "connect.keys.graceUntil": "revoked {date}",
  "connect.keys.rotate": "Replace",
  "connect.keys.noManage": "Only people with integration management can replace or add keys.",
  "connect.keys.org": "Org reports give per-key daily totals (not per person).",
  "connect.keys.src": "API key registry",
  "connect.rot.title": "Replace the {alias} key",
  "connect.rot.st.active": "In use",
  "connect.rot.st.grace": "7-day grace",
  "connect.rot.st.revoked": "Revoked",
  "connect.rot.desc": "Once you add a new key, the current key stays in a 7-day grace period and is then revoked automatically. Both keys work during that time.",
  "connect.rot.newKey": "New key (from the AI company’s console)",
  "connect.rot.newKeyHint": "It’s stored encrypted and only the last 4 characters are kept. It’s never shown again.",
  "connect.rot.confirm": "Start replacing",
  "connect.rot.err": "Enter the new key (8+ characters).",
  "connect.rot.done": "Replacement started. The old key will be revoked {date}.",
  "connect.team.q": "Is anyone disconnected?",
  "connect.team.qTeam": "Is any teammate disconnected?",
  "connect.team.tech": "Person × tool · disconnected first · {scope}",
  "connect.team.scopeTeam": "my team ({team})",
  "connect.team.scopeAll": "everyone",
  "connect.team.scopeAllTeam": "everyone · {team} only",
  "connect.team.sum": "Check connections for {bad} of {p} people.",
  "connect.team.sumErr": "{e|connection is|connections are} down with an error.",
  "connect.team.sumNone": "All {p} people’s connections are fine.",
  "connect.team.filter": "Show",
  "connect.team.f.attention": "Needs a look {n}",
  "connect.team.f.all": "All {n}",
  "connect.team.allOk": "Nothing needs a look",
  "connect.team.never": "Never connected",
  "connect.team.noRx": "nothing received",
  "connect.team.idle": "No records for over 3 days shows as “Not connected”. Fine if they didn’t use it. No record ≠ not used.",
  "connect.team.excluded": "Other managers, admins and content reviewers on the team aren’t shown ({n|person|people}).",
  "connect.team.revokeNote": "Disconnecting someone else is kept in the access & change log and the person is notified.",
  "connect.team.emptyWhat": "No people match.",
  "connect.team.emptyNot": "Try another view scope or team.",
  "connect.col.person": "Person",
  "connect.col.team": "Team",
  "connect.col.tool": "Tool",
  "connect.col.status": "Status",
  "connect.col.why": "Reason",
  "connect.col.last": "Last received",
  "connect.col.version": "CLI version",
  "connect.col.act": "Actions",
  "connect.col.app": "App",
  "connect.col.provider": "AI company",
  "connect.col.expires": "Expires",
  "connect.col.lastUsed": "Last used",
  "connect.col.alias": "Alias",
  "connect.col.last4": "Last 4",
  "connect.col.keyId": "AI company key ID",
  "connect.col.workspace": "Workspace",
  "connect.col.owner": "Owner",
  "connect.col.source": "Source",
  "connect.col.kind": "Kind",
  "connect.col.target": "For",
  "connect.col.token": "Connection token",
  "connect.col.verState": "Check",
  "connect.col.pc": "Tool · PC",
  "connect.exp.q": "Are any connection tokens about to expire?",
  "connect.exp.tech": "Connection tokens · expiring within 14 days · already expired",
  "connect.exp.sum": "{n|token expires|tokens expire} within 14 days or already expired.",
  "connect.exp.sumNone": "No connection tokens expire within 14 days.",
  "connect.exp.auto": "The owner is reminded 14 days before expiry.",
  "connect.exp.needNew": "New connection token needed",
  "connect.kind.collect": "Collect token",
  "connect.kind.gateway": "Gateway token",
  "connect.kind.service": "Service account token",
  "connect.sup.q": "Which tool sends which values?",
  "connect.sup.tech": "Support table · tool, version, OS, auth × item",
  "connect.sup.sum": "Minimum supported versions: Claude Code {c} · Codex {x}. New versions being checked: {chk}.",
  "connect.sup.none": "none",
  "connect.sup.tool": "Tool · version · OS · auth",
  "connect.sup.region": "Support table (scrolls sideways)",
  "connect.sup.osNa": "Any OS",
  "connect.sup.target": "Cell linked from that badge",
  "connect.sup.cellDate": "Measured {date}",
  "connect.sup.src": "Support table last checked {date}",
  "connect.sup.lg": "How to read",
  "connect.sup.lg.verified": "Confirmed by sending from the real CLI",
  "connect.sup.lg.source": "Confirmed in public source code",
  "connect.sup.lg.doc": "Only in official docs (not measured yet)",
  "connect.sup.lg.conditional": "Arrives only with the right setting, version or level",
  "connect.sup.lg.unofficial": "Not in the official list",
  "connect.sup.lg.unsupported": "The tool doesn’t send it",
  "connect.sup.lg.na": "Doesn’t exist for that method",
  "connect.sup.lg.checking": "Support is being checked",
  "connect.ver.q": "Which CLI versions did my PCs send?",
  "connect.ver.tech": "CLI versions received · my PCs",
  "connect.ver.sumOk": "Every CLI on my PCs is a supported version ({n|CLI|CLIs}).",
  "connect.ver.sumWarn": "Check {w} of {n}.",
  "connect.ver.emptyWhat": "No CLI versions received yet.",
  "connect.ver.policy": "Below the minimum version, only basic information is stored; text and work details are dropped. Unmeasured versions follow consent and show a checking badge. A version badge does not verify every OS or authentication mode.",
  "connect.ver.latest": "latest checked {v}",
  "connect.cov.q": "What can and can’t be recorded?",
  "connect.cov.tech": "Item × how used · available · conditional · not possible · not applicable",
  "connect.cov.sum": "The same item can differ by tool and method. Open a cell to see the conditions.",
  "connect.cov.y": "Available",
  "connect.cov.c": "Conditional",
  "connect.cov.n": "Not possible",
  "connect.cov.na": "Not applicable",
  "connect.cov.item": "Item",
  "connect.cov.cellTitle": "{item} · {ch}",
  "connect.cov.ch.claude_code": "Claude Code",
  "connect.cov.ch.codex": "Codex",
  "connect.cov.ch.anthropic_api": "Anthropic API key",
  "connect.cov.ch.openai_api": "OpenAI API key",
  "connect.cov.ch.org_report": "Org report",
  "connect.cov.it.prompt": "Questions",
  "connect.cov.it.usage": "Usage",
  "connect.cov.it.files": "Files opened",
  "connect.cov.it.changes": "Changes",
  "connect.cov.it.time": "Time",
  "connect.cov.it.model": "AI model",
  "connect.cov.it.actions": "Actions by AI · errors",
  "connect.cov.naNote": "This method has no such value.",
  "connect.cov.orgNote": "Org reports are daily totals by model and key, so this value isn’t there.",
  "connect.cov.n.prompt.claude_code": "Question text is kept at recording level ② or higher when the CLI’s question-text setting is on. Otherwise only the character count.",
  "connect.cov.n.prompt.codex": "Question text is kept at level ② or higher when Codex’s question-text setting is on.",
  "connect.cov.n.prompt.api": "The last question of a gateway call is kept — only when the app’s text policy is on (default: basic info only).",
  "connect.cov.n.usage.claude_code": "Newly read, read from cache, saved to cache and written by AI arrive per request.",
  "connect.cov.n.usage.codex": "Aligned as “newly read = input − cache”. Totals are being verified.",
  "connect.cov.n.usage.anthropic_api": "The gateway reads usage from the response.",
  "connect.cov.n.usage.openai_api": "The gateway reads it. If a stream has no usage, it’s “unknown” (not 0).",
  "connect.cov.n.usage.org_report": "Daily totals by model and key. Never added to per-person records.",
  "connect.cov.n.files.claude_code": "Paths are kept at level ④ when the CLI’s work-details setting is on. File contents aren’t.",
  "connect.cov.n.files.codex": "Estimated paths taken from shell commands (level ④).",
  "connect.cov.n.changes.claude_code": "Needs level ④ and the CLI’s work-details setting on. Before/after values arrive as the first 128 characters each.",
  "connect.cov.n.changes.codex": "The full patch arrives. It’s stored at level ④.",
  "connect.cov.n.time.claude_code": "Time used, time the chat was open and wait time are kept. AI active time needs metrics export on.",
  "connect.cov.n.time.codex": "Time used, time the chat was open and wait time are kept. Codex doesn’t send AI active time.",
  "connect.cov.n.time.api": "Call time and wait time are kept. Time the chat was open is known only with a conversation header.",
  "connect.cov.n.time.org_report": "Only the date (daily).",
  "connect.cov.n.model.claude_code": "The AI model and thinking depth arrive with each question.",
  "connect.cov.n.model.codex": "The AI model and thinking depth arrive. Questions and calls are matched by time order (estimated link).",
  "connect.cov.n.model.api": "The AI model is kept. Thinking depth needs more request-body parsing, so it’s conditional.",
  "connect.cov.n.model.org_report": "Daily totals per model.",
  "connect.cov.n.actions.claude_code": "Tool runs, allow/reject, errors and retries are kept. Command strings need level ④ and the CLI’s work-details setting on.",
  "connect.cov.n.actions.codex": "Commands and the start of their output always arrive. Storage follows your recording level.",
  "connect.cov.n.actions.api": "Only errors and retries. API key calls have no tool actions.",
  "connect.cov.n.actions.org_report": "Only accept/reject totals from Claude Code org statistics.",
  "connect.cov.never.q": "What can’t be recorded by any method?",
  "connect.cov.never.tech": "Not recordable · tools don’t send it, or we don’t store it",
  "connect.cov.never.1": "Earlier versions of a re-sent question, and drafts in the input box",
  "connect.cov.never.2": "The AI’s intermediate thinking (never stored even if sent)",
  "connect.cov.never.3": "File changes made with shell commands (sed -i, Set-Content…) — only the command string remains",
  "connect.cov.never.4": "Standard whole-file diffs for Claude",
  "connect.cov.never.5": "File contents Claude read, on the default path",
  "connect.cov.dont.q": "What does this system not do?",
  "connect.cov.dont.tech": "Things we don’t do · purpose limits",
  "connect.cov.dont.1": "It doesn’t watch keystrokes, screens or network traffic.",
  "connect.cov.dont.2": "It doesn’t store the AI’s intermediate thinking.",
  "connect.cov.dont.3": "It doesn’t judge AI contribution rates.",
  "connect.cov.src": "Assessed October 2026 · updated together with the support table",
  "connect.days.title": "Collection over the last 14 days",
  "connect.days.question": "On which days did each device send records?",
  "connect.days.fixedRange": "This table always shows the last 14 days including today, independently of the period above.",
  "connect.days.range": "{from}–{to} · Organisation time zone: {timezone} · Today is in progress",
  "connect.days.legend": "Legend for daily collection states",
  "connect.days.device": "Device",
  "connect.days.state.received": "Received",
  "connect.days.state.all_dropped": "Received, all dropped",
  "connect.days.state.no_receipt": "Nothing received",
  "connect.days.state.before_connection": "Before connection",
  "connect.days.counts": "Received {received} · Stored {stored} · Duplicates {duplicates} · Dropped {dropped}",
  "connect.days.unknown": "The server received no records. The reason is unknown.",
  "connect.days.before": "This date is before the device was connected.",
  "connect.days.note": "Nothing received does not mean AI was not used. Select a date for receipt counts and reasons for dropped records.",
  "connect.days.empty": "There are no devices to check yet.",
  "connect.days.unavailable": "Collection status by device is not available yet.",
  "connect.days.revoked": "Disconnected",
  "connect.days.prev": "Previous devices",
  "connect.days.next": "Next devices",
  "connect.days.page": "Devices {from}–{to} of {total}",
};

export default connect;
